import { Util } from '@libs/utilities/util';

import { IAmazonCompositeKeywordData, IGoogleSearchVolumeValue } from '../../../../constants/research';
import { SearchVolumeEvaluatorHelper } from './search-volume-evaluator.helper';
import { ISearchVolumeTrendEvaluation } from './search-volume-evaluator.interface';


export class GoogleSvEvaluatorService {

	//** Configurations */
	private readonly MAX_GOOGLE_CMP: number = 100;
	private readonly MIN_GOOGLE_CMP: number = 0;

	constructor(
		private searchVolumeEvaluatorHelper: SearchVolumeEvaluatorHelper
	) {}


	/**------------------------------------------------------
	 * Search Volume & Trends
	 */
	current(keywordData: IAmazonCompositeKeywordData): number {
		return this.searchVolumeEvaluatorHelper.current(keywordData.google.searchVolume.history);
	}

	history(keywordData: IAmazonCompositeKeywordData, monthDuration: number = 12): IGoogleSearchVolumeValue[] {
		return this.searchVolumeEvaluatorHelper.history(keywordData.google.searchVolume.history, monthDuration);
	}

	trends(keywordData: IAmazonCompositeKeywordData): ISearchVolumeTrendEvaluation {
		return this.searchVolumeEvaluatorHelper.trends(keywordData.google.searchVolume.history);
	}


	/**------------------------------------------------------
	 * CMP & CPC
	 */
	cmp(keywordData: IAmazonCompositeKeywordData): number | null {
		let googleCmp: number = keywordData.google.searchVolume.cmp;
		if (!googleCmp) return null;

		if (googleCmp > this.MAX_GOOGLE_CMP) googleCmp = this.MAX_GOOGLE_CMP;
		if (googleCmp < this.MIN_GOOGLE_CMP) googleCmp = this.MIN_GOOGLE_CMP;
		return Util.Number.roundDouble(googleCmp);
	}

	cpc(keywordData: IAmazonCompositeKeywordData): number {
		return keywordData.google.searchVolume.cpc;
	}
}
